module.exports = __webpack_public_path__ + "img/assistant_tourisme-1.e0b87dcf.jpg";